<template>
  <div class="dh-content">
    <div class="dh-title">
      <slot name="title">{{ title }}</slot>
    </div>
    <div class="dh-data" :style="colorComputed">
      <slot name="data">{{ data }}</slot>
    </div>
    <div class="dh-subtitle">
      <slot name="subtitle">{{ subtitle }}</slot>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { useTheme } from "@/utils/index";

export default {
  name: "CardDataHighlight",
  props: {
    title: String,
    subtitle: String,
    data: [String, Number],
    color: {
      type: String,
      default: "alpha",
    },
  },
  setup(props) {
    const { theme } = useTheme();

    const colorComputed = computed(() => {
      return `color: ${theme.value?.iconColors?.[props.color] || theme.value?.iconColors?.default}`;
    });
    return { colorComputed };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.dh-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100%;
}
.dh-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.875rem;
}
.dh-data {
  font-size: 2.375rem;
  font-weight: bold;
  letter-spacing: 0.29px;
}
.dh-subtitle {
  font-size: 0.875rem;
}
</style>
